import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { errorPageActions } from '~/components';

export const NotFound = ({ dispatchSetErrorStatus }) => {
  dispatchSetErrorStatus(404);
  return null;
};

export const mapDispatchToProps = {
  dispatchSetErrorStatus: errorPageActions.setErrorStatus,
};

export const ConnectedNotFound = connect(null, mapDispatchToProps)(NotFound);

NotFound.propTypes = {
  dispatchSetErrorStatus: PropTypes.func.isRequired,
};
